import request from '../utils/Request';
import { Methods } from '../config';
import { downloadFile } from '../utils/download';

const baseURL = 'supportingDocument';

const supportingDocumentService = {
  getData: (docId, documentTypeId) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/data`,
      data: { docId, documentTypeId },
    });
  },

  print: async (data) => {
    const file = await request({
      method: Methods.POST,
      resource: `${baseURL}/print`,
      responseType: 'blob',
      data,
    });

    downloadFile(file, file.filename);
    return file;
  },
};

export default supportingDocumentService;
